<template>
  <div style="margin-top:20px;">
    <CRow>
      <CCol lg="12">
        <GlobalTable
          :title="'Voucher'"
          :fields="fields"
          :items="voucher"
          :editButton="false"
          :redirectDetail="false"
          :addButton="true"
          :isLoading="isLoading"
          :withCard="false"
          :removeButton="true"
          @addForm="addForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>
    
    <CModal title="Modal title" color="success" size="xl" :closeOnBackdrop="false" :show.sync="addButton">
        <template #header>
            <h6 class="modal-title">Add Form Address</h6>
        </template>

        <Loading v-if="isLoading"></Loading>
        <div v-else>
            <CRow>
            <CCol sm="3">
                <div class="form-group">
                <label for="voucher_code">Voucher</label>
                <model-select
                    class="form-control"
                    id="voucher_code"
                    :options="listVoucherCode"
                    v-model="$v.userVoucherForm.voucher_code.$model"
                    :isError="$v.userVoucherForm.voucher_code.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                ></model-select>
                    <div v-if="$v.userVoucherForm.voucher_code.$invalid" class="invalid-feedback-custom">Voucher should be filled.</div>
                </div>
            </CCol> 
            </CRow>
        </div>

        <template #footer>
            <CButton @click="cancelForm" color="danger">
            <i class="fa fa-undo"></i>
            Cancel
            </CButton>
            <CButton @click="submitForm" :disabled="$v.userVoucherForm.$invalid" color="success">
            <i class="fa fa-save"></i>
            Accept
            </CButton>
        </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UserVoucher",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "AgentCoverage",
      listVoucherCode: [],
      addButton: false,
      isEdit: false,
      isLoading: false,
      userVoucherForm: tableInterfaces.user_voucher,
    //   checkedFlag: "Agent",
      fields: [
        { key: "voucher_code", label: "Voucher Code", sorter: true },
        { key: "name", label: "Title", sorter: true },
        { key: "start_date", label: "Voucher Start", sorter: true },
        { key: "end_date", label: "Voucher Expired", sorter: true },
        { key: "used_status", label: "Status Voucher"},
        { key: "action", label: "Action"}

      ],
    };
  },
  props: {
    voucher: {
      type: [Array, Object],
      default: () => [],
    },
    userCode: {
      type: String,
      default: null,
    },
  },
  validations: {
    userVoucherForm: {
      user_code: {  },
      voucher_code: { required }
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
        this.$emit('update:userCode', this.userCode);
        this.axios.get("console/dropdown/voucher-by/"+this.userCode)
        .then((response) => {
          if (response.data.status === 2000) {
            this.listVoucherCode = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function() {
        this.resetForm();
        this.addButton = true;
    },
    cancelForm: function() {
        this.resetForm();
        this.addButton = false;
    },
    removeData: function(e) {
      if(confirm('Are you sure want to remove this?')) {
            this.isLoading = true;
            this.axios.delete("console/users/remove-voucher/"+this.userCode+"/"+e.voucher_code)
            .then((response) => {
            if (response.data.status === 2000) {
                this.showInfoNotification({
                title: this.title,
                message: response.data.message,
                });
            } else {
                this.showErrorNotification({
                title: this.title,
                message: response.data.message,
                });
            }
            })
            .catch((error) => {
            this.showErrorNotification({
                title: this.title,
                message: error,
            });
            })
            .finally(() => {
              this.isLoading = false;
              this.$router.go(0);
            });
        }
    },
    resetForm: function () {
      for (var i in tableInterfaces.user_voucher) {
        tableInterfaces.user_voucher[i] = null;
      }
      this.userVoucherForm = tableInterfaces.user_voucher;
    },
    submitForm: function(e) {
        e.preventDefault();
        if(confirm('Are you sure want to add this?')) {
            this.isLoading = true;
            this.userVoucherForm.user_code = this.userCode;
            this.axios.post("console/users/insert-voucher", this.userVoucherForm)
            .then((response) => {
            if (response.data.status === 2000) {
                this.showInfoNotification({
                title: this.title,
                message: response.data.message,
                });
            } else {
                this.showErrorNotification({
                title: this.title,
                message: response.data.message,
                });
            }
            })
            .catch((error) => {
            this.showErrorNotification({
                title: this.title,
                message: error,
            });
            })
            .finally(() => {
              this.isLoading = false;
              this.$router.go(0);
            });
        }
    }
  },
  mounted() {
      this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
